import { render, staticRenderFns } from "./reversed.vue?vue&type=template&id=365e9f6f&scoped=true"
import script from "./reversed.vue?vue&type=script&lang=js"
export * from "./reversed.vue?vue&type=script&lang=js"
import style0 from "./reversed.vue?vue&type=style&index=0&id=365e9f6f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "365e9f6f",
  null
  
)

export default component.exports